// cleanup_convert_to_typescript_file_GENERICS

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Typography, { variants, weights } from 'components/typography/Typography';
import { DEFAULT_PROPS } from 'constants.js';

import { LABEL, LINK_ADD_WIDGET, LINK_INITIATE } from './ListPill.constants';
import useStyles from './listPill.styles';

const { EMPTY_FUNCTION, NULL } = DEFAULT_PROPS;

export const ListPillCustomLinkComponent = ({
  linkRole = NULL,
  onChange = EMPTY_FUNCTION,
  params
}) => {
  const { linkLabel, linkTitle } = useStyles();
  const { dataQa, name, path, state = [], type = '', value } = params.option;

  if ([LINK_ADD_WIDGET, LINK_INITIATE].includes(name)) {
    return null;
  }
  const props = {
    key: name
  };

  const isLinkType = path;
  const isLabel = type === LABEL;

  const buttonsProps = {
    ...props,
    onClick: () => {
      onChange(value);
    },
    to: {},
    value
  };
  const linksProps = {
    ...props,
    onClick: () => {
      onChange([params.option]);
    },
    to: {
      pathname: path,
      state
    }
  };

  return isLabel ? (
    <Typography className={linkLabel} variant={variants.smallLabel} weight={weights.medium}>
      {name}
    </Typography>
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Link {...(!isLinkType ? buttonsProps : linksProps)} data-qa={dataQa} role={linkRole}>
      <Typography className={linkTitle} variant={variants.linkTitle}>
        {name}
      </Typography>
    </Link>
  );
};

ListPillCustomLinkComponent.propTypes = {
  onChange: PropTypes.func,
  params: PropTypes.shape({
    onClick: PropTypes.func,
    option: PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
      permission: PropTypes.shape([]),
      state: PropTypes.shape({}),
      type: PropTypes.string,
      value: PropTypes.string,
      dataQa: PropTypes.string
    })
  }).isRequired,
  state: PropTypes.shape({}).isRequired,
  linkRole: PropTypes.string
};

export default ListPillCustomLinkComponent;
